import React from 'react';
import { DateRangePicker } from 'react-date-range';
import { SESSION_OPTIONS } from './constants';
import '../../search/assets/css/date-search.css';
import './assets/css/search_fields.css';

const ExactDateSelection = ({
  dateSearchState,
  updateDateSearchState,
  handleDateChange,
  calendarProps,
}) => {
  const handleRangeChange = ({ selection }) => {
    if (!selection.startDate) {
      // Needed for the clear selection button -- seems to be an issue in the library where sometimes it
      //   interprets a null startDate as valid and only returns a selected endDate
      selection.startDate = selection.endDate;
    }

    // This is to render in time selection page
    selection['end_date'] = selection['endDate'];
    handleDateChange(selection);
  };

  return (
    <>
      <div className='search-date-range-picker gRegular' id='search-bar-new'>
        <DateRangePicker
          onChange={handleRangeChange}
          minDate={new Date()}
          months={1}
          ranges={dateSearchState?.bookingDates}
          showPreview={false}
          direction='horizontal'
          color='black'
          rangeColors={['black', 'white']}
          {...calendarProps}
        />
      </div>
      <p className='gSemiBold fs-14 grey-900 mg-top-15 mg-bottom-10'>
        Or choose a popular session length
      </p>
      <div className='session-grid gMedium'>
        {SESSION_OPTIONS.map((option) => {
          const isSelected = dateSearchState?.selectedSession === option;
          return (
            <button
              key={option}
              aria-pressed={isSelected}
              className={`session-btn ${isSelected ? 'active' : ''}`}
              onClick={() => updateDateSearchState('selectedSession', option)}
            >
              {option}
            </button>
          );
        })}
      </div>
    </>
  );
};

export default ExactDateSelection;
